 /* @ngInject */
export default class UtilityinfoCtrl {
  constructor(
    $sce,
    $scope,
    $timeout,
    $rootScope,
    BuildingsService,
    NavigationService,
    LocalStorageService,
    DashboardService,
  ) {
    this.$sce = $sce;
    this.$scope = $scope;
    this.$timeout = $timeout;
    this.$rootScope = $rootScope;
    this.BuildingsService = BuildingsService;
    this.NavigationService = NavigationService;
    this.LocalStorageService = LocalStorageService;
    this.DashboardService = DashboardService;

    this.init();
    this.activate();
  }

  async init() {
    this.isBusy = true;
  }

  async activate() {
    this.selectedBuildingRef = this.BuildingsService.getSelectedBuildingRef();

		let buildingName = '';
		const userProfile = this.LocalStorageService.retrieve('userProfile');

		if (userProfile) {
			if (!this.selectedBuildingRef) {
                this.selectedBuildingRef = userProfile.BuildingProfiles[0].SchemeReference;
            }
			const selectedBuilding = userProfile.BuildingProfiles.find((building) => {
				return building.SchemeReference.toUpperCase().trim() === this.selectedBuildingRef.toUpperCase().trim();
			});

			if (selectedBuilding) {
				buildingName = selectedBuilding.SchemeName;
			}
		}
    await this.getUtilityinfo();
  }

  async _onSelectedBuildingChanged(event, schemeRef) {
    try {
      if (schemeRef) {
        this.activate();
      }
    } catch (err) {
      console.error('Error while loading utility information:', err);
    } finally {
      this.isBusy = false;
    }
  }

  async getUtilityinfo() {
    this.isBusy = true;
    this.$timeout(async () => {
      try {
        if (this.selectedBuildingRef && this.selectedBuildingRef != null) {
          let utilityinfo = await this.DashboardService.getBuildingUtilityInformation(this.selectedBuildingRef);
          this.$scope.$applyAsync(() => { this.utilityinfo = utilityinfo; });
      }

      } catch (err) {
        console.error('Error while loading utility information:', err);
      } finally {
        this.$scope.$applyAsync(() => { this.isBusy = false; });
      }
    });
  }
}
